import React, { useEffect, useState } from "react";
import Shimmer from "../Shimmer";
import { useParams } from "react-router-dom";
import useResMenu from "../../customhooks/useResMenu";
import ResMenuHeader from "./ResMenuHeader";
import menu from "../../utils/menu";

const ResMenu = () => {
  // State for restaurant menu data
  const [resInfo, setResInfo] = useState(null);
  
  // for controlling the child component state
  const [showIndex, setShowIndex] = useState();

  useEffect(() => {
    // Replace with actual menu data fetching logic if necessary
    setResInfo(menu);  // assuming `menu` is a valid imported object
  }, []);

  console.log('The menu is ',menu)
  console.log('the resInfo is ',resInfo)

  if (resInfo === null) {
    return <Shimmer />;
  }

  const { name, cuisines } = resInfo[0]?.data?.cards[2]?.card?.card?.info;
  console.log('The name is',name);

  const allCards = resInfo[0]?.data?.cards?.[5]?.groupedCard?.cardGroupMap?.REGULAR?.cards;

  // Step 1: Filter categories
  const filteredCategories = allCards.filter(
    (res) =>
      res?.card?.card?.["@type"] ===
      "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory"
  );

  // Step 2: Map filtered categories to a simpler structure
  const categories = filteredCategories.map((category) => ({
    title: category?.card?.card?.title,
    itemCards: category?.card?.card?.itemCards,
  }));

  return (
    <div className="bg-white w-6/12 mt-[120px] mx-auto flex flex-col gap-3">
      <div>
        <h2 className="text-blue-500 text-center">Menu</h2>
       
      </div>
      {/* controlled component */}
      {categories.map((category, index) => (
        <ResMenuHeader
          key={index}
          category={category}
          showIndex={index === showIndex}
          setShowIndex={() => setShowIndex(index === showIndex ? null : index)}
        />
      ))}
    </div>
  );
};

export default ResMenu;
